import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import useStore from "../../../../useStore";
import Loader from "../../../Elements/Loader/Loader";
import "./detalleOrden.css";

const LOW_STOCK_THRESHOLD = 50; // ajusta

const DetalleOrden = () => {
    const { ordenId } = useParams();

    const fetchDisponibilidadPorOrden = useStore((s) => s.fetchDisponibilidadPorOrden);
    const disponibilidadOrden = useStore((s) => s.disponibilidadOrden) || [];
    const loading = useStore((s) => s.loading);
    const error = useStore((s) => s.error);

    useEffect(() => {
        if (ordenId) fetchDisponibilidadPorOrden(ordenId);
    }, [ordenId, fetchDisponibilidadPorOrden]);

    // Agrupa por producto (opcional, se ve más limpio)
    const datosAgrupados = useMemo(() => {
        const map = new Map();
        disponibilidadOrden.forEach((row) => {
            const key = row.producto;
            if (!map.has(key)) map.set(key, []);
            map.get(key).push(row);
        });
        return Array.from(map.entries()); // [ [producto, rows[]], ...]
    }, [disponibilidadOrden]);

    return (
        <div className="do-wrapper container-mh">
            <h2 className="do-title">
                Detalle de Orden: <span className="text-primary">{ordenId}</span>
            </h2>

            {loading && <Loader />}

            {!loading && error && (
                <div className="alert alert-danger mt-3">
                    Error al obtener disponibilidad: {error}
                </div>
            )}

            {!loading && !error && disponibilidadOrden.length > 0 && (
                <div className="do-content">
                    {datosAgrupados.map(([producto, rows], idx) => {
                        const total = rows.reduce((s, r) => s + (r.cantidad_disponible || 0), 0);
                        return (
                            <section key={idx} className="do-card">
                                <header className="do-card-header">
                                    <h5 className="do-producto">{producto}</h5>
                                    <span className="do-total">
                                        Total:{" "}
                                        <strong>{total.toLocaleString("es-MX")}</strong>
                                    </span>
                                </header>

                                <div className="do-stock-bar">
                                    <div
                                        className="do-stock-fill"
                                        style={{ width: `${Math.min(total / 1000, 1) * 100}%` }}
                                    />
                                </div>

                                <div className="table-responsive do-table-wrapper">
                                    <table className="do-table">
                                        <thead>
                                            <tr>
                                                <th>Almacén</th>
                                                <th className="text-end">Cantidad</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rows.map((r, i) => {
                                                const low = (r.cantidad_disponible || 0) <= LOW_STOCK_THRESHOLD;
                                                return (
                                                    <tr key={i} className={low ? "low-stock" : ""}>
                                                        <td data-label="Almacén">{r.almacen}</td>
                                                        <td
                                                            data-label="Cantidad"
                                                            className="text-end fw-semibold"
                                                        >
                                                            {r.cantidad_disponible?.toLocaleString("es-MX")}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                        );
                    })}
                </div>
            )}

            {!loading && !error && disponibilidadOrden.length === 0 && (
                <p className="text-muted text-center mt-4">
                    No hay disponibilidad registrada para esta orden.
                </p>
            )}
        </div>
    );
};

export default DetalleOrden;
